<template>
    <div class="modelingCennert">
        <div class="modeling_na">
            <h1>云创5G工业IOT监控系统</h1>
            <p>仿生3D联动,数字孪生,助理企业智能化管理</p>
            <ul>
                <li><span>·</span>3D产品展示</li>
                <li><span>·</span>沙盘数据监控</li>
                <li><span>·</span>3D房产沙盘</li>
                <li><span>·</span>3D建筑动画</li>
            </ul>
            <div data-aos="fade-up">
            <div class="modeling_video">
                <img  @click="bedonevideo_play" v-if="!bedonevideo" src="https://oss.3dyunchuang.com/home_pic/video/3dtable.jpg"/>
                     <div class="suspend" @click="bedonevideo_play" v-if="!bedonevideo">
                                <img src="../../assets/imges/suspend.png"/>
                        </div>
                 <video v-if="bedonevideo" style="object-fit: fill; background: #000000;" id="vio" width="100%" height="100%" controls="controls" autoplay="autoplay">
                        <source src="https://oss.3dyunchuang.com/home_pic/video/3dtable.mp4" type="video/mp4">
                </video>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
 data() {
        return {
            bedonevideo:false
        }
 },
 methods:{
   bedonevideo_play(){
       this.bedonevideo = true
   }
  }
}
</script>
<style scoped>
.modelingCennert{
    width: 100%;
    height: 1004px;
    background: url("../../assets/imges/3Dmodeling/video2.png") no-repeat center;
}
.modeling_na{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.modeling_na h1{
    font-size: 36px;
    letter-spacing:1.5px;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 5px;
    margin-left: 17px;
}
.modeling_na P{
    font-size: 20px;
    color: #666666;
    text-align: center;
    margin-bottom: 50px;
      margin-left: 17px;
}
.modeling_na ul{
    width: 560px;
    height: 25px;
    margin: 0 auto;
}
.modeling_na ul li{
    float: left;
    font-size: 18px;
    margin-right: 15px;
    font-weight: bold;
    letter-spacing:1px;
}
.modeling_na ul li span{
    color: #357eff;
    margin-right: 8px;
}
.modeling_video{
    width: 1000px;
    height: 591px;
    text-align: center;
    cursor: pointer;
    position:relative;
    margin: 28px auto;
    overflow: hidden;
    background: #fff;
    border-radius: 20px;
    box-shadow: 1px 6px 15px rgba(0,0,0,.5);
}
.modeling_video img{
    width: 958px;
    height: 540px;
    margin-top: 25px;
}
#vio{
    position: absolute;
    left: 21px;
    top: 25px;
      width: 958px;
    height: 540px;
 
}
.suspend{
    position: absolute;
    left: 50%;
    top: 45%;
    z-index: 9;
    transform: translate(-50%,-50%);
    width: 91px;
    height: 91px;
}
.suspend img{
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/common/modeling/modeling-cennert.vue